export const state = {
    banco: {},
    bancos: [],
    modalExcluirBanco: false,
    modalCadastrarBanco: false,
}

export default {}